module.exports = __webpack_public_path__ + "img/occasions-sprite.36596931.svg";